import React, { Suspense } from 'react'
import './assets/styles/App.scss'
import 'antd/dist/antd.min.css'
import './assets/styles/custom.scss'
import routes from './router'
import { Route, Switch, Redirect } from 'react-router-dom'
import { getAccessAllToken, isLoggedIn, isLoggedInAll } from './utils/userUtils'
import { redirectToSsoConsumer } from './utils/ssoRedirect'

const SsoRedirecting = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, sans-serif',
      color: '#344054',
      background: '#f9fafb',
    }}
  >
    Đang chuyển hướng đăng nhập SSO…
  </div>
)

const App: React.FC = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        {routes.map(({ component: Component, path, exact, name, layout: Layout }) => (
          <Route
            key={name}
            exact={exact}
            path={path}
            render={(props: any) => {
              const urlParams = new URLSearchParams(window.location.search)
              const hethong = urlParams.get('hethong')
              const redirectUrl = urlParams.get('redirect_url')
              const isSsoLoginRoute = typeof path === 'string' && path.includes('login-all')
              const isSsoLogoutRoute = typeof path === 'string' && path.includes('logout-all')

              // Đã có access_all_token còn hạn + vào login-all → đẩy về app con (cùng tab).
              if (isSsoLoginRoute && isLoggedInAll() && hethong) {
                const token = getAccessAllToken()
                if (token && redirectToSsoConsumer(hethong, redirectUrl, token)) {
                  return <SsoRedirecting />
                }
              }

              const allowPublicSso =
                path === '/login'
                || isSsoLoginRoute
                || isSsoLogoutRoute

              return (
                <Layout>
                  {isLoggedIn() ? (
                    path === '/login' ? (
                      <Redirect push to="/" />
                    ) : (
                      <Component {...props} />
                    )
                  ) : allowPublicSso ? (
                    <Component {...props} />
                  ) : (
                    <Redirect push to="/login" />
                  )}
                </Layout>
              )
            }}
          />
        ))}
      </Switch>
    </Suspense>
  )
}

export default App
